import { create } from 'zustand';

const useLoyaltyPointLog = create((set) => ({
  // Filters & Selection
  sortingData: false,
  setSortingData: (sort) => set({ sortingData: sort }),

  schedularDate: {},
  setSchedularDate: (date) => set({ schedularDate: date }),

  selectedStatus: 'ALL',
  setSelectedStatus: (status) => set({ selectedStatus: status }),

  upDateSelectedStatus: [],
  setUpDateSelectedStatus: (statusArray) => set({ upDateSelectedStatus: statusArray }),
  
  useEffectCall: false,
  setUseEffectCall: (call) => set({useEffectCall : call}),

  homeDeliveryValue: false,
  setHomeDeliveryValue: (call) => set({homeDeliveryValue : call}),
  urgentDeliveryValue: false,
  setUrgentDeliveryValue: (call) => set({urgentDeliveryValue : call}),

  loyaltyPointLogData: [],
  setLoyaltyPointLogData: (updater) =>
    set((state) => ({
      loyaltyPointLogData:
        typeof updater === 'function' ? updater(state.loyaltyPointLogData) : updater,
    })),

    loyaltyPointPointLogData: [],
    setLoyaltyPointPointLogData: (updater) =>
      set((state) => ({
        loyaltyPointPointLogData:
          typeof updater === 'function' ? updater(state.loyaltyPointPointLogData) : updater,
      })),

      loyaltyPointCashLogData: [],
    setLoyaltyPointCashLogData: (updater) =>
      set((state) => ({
        loyaltyPointCashLogData:
          typeof updater === 'function' ? updater(state.loyaltyPointCashLogData) : updater,
      })),
  

  statusTotalData: [],
  setStatusTotalData: (data) => set({ statusTotalData: data }),

  sumOfGrandTotal: 0,
  setSumOfGrandTotal: (total) => set({ sumOfGrandTotal: total }),

  sumOfOrderCount: 0,
  setSumOfOrderCount: (count) => set({ sumOfOrderCount: count }),

  // Pagination
  page: 0,
  // setPage: (newPage) => set({ page: newPage }),
  setPage: (updater) =>
    set((state) => ({
      page:
        typeof updater === 'function' ? updater(state.page) : updater,
    })),
}));

export default useLoyaltyPointLog;
